import { Alert } from '@amzn/awsui-components-core';
import { Button } from '@amzn/awsui-components-core';

export interface ContentLoadingErrorAlertProps {
  readonly message: string;
}

export default function ContentLoadingErrorPage({ message }: ContentLoadingErrorAlertProps) {
  // TODO: this will be replaced by proper error pages.
  // For now I will just use an alert.
  // https://taskei.amazon.dev/tasks/P422966146
  return (
    <Alert
      type="error"
      action={<Button onClick={() => window.location.reload()}>Retry</Button>}
      header="Failed to load content"
    >
      {message}
    </Alert>
  );
}
